import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    itemInCart: [],
  },
  reducers: {
    setItemInCart: (state, action) => {
      state.itemInCart.push(action.payload);
    },
    deleteItemInCart: (state, action) => {
      state.itemInCart = state.itemInCart.filter(
        (shoes) => shoes.id !== action.payload
      );
    },
    setItemInCart: (state, action) => {
      const item = action.payload;
      const existing = state.itemInCart.find((i) => i.id === item.id);

      if (existing) {
        existing.quantity += 1;
      } else {
        state.itemInCart.push({ ...item, quantity: 1 });
      }
    },
    increaseQty: (state, action) => {
      const item = state.itemInCart.find((i) => i.id === action.payload);
      if (item) item.quantity += 1;
    },

    decreaseQty: (state, action) => {
      const item = state.itemInCart.find((i) => i.id === action.payload);
      if (item && item.quantity > 1) {
        item.quantity -= 1;
      }
    },

    deleteItemInCart: (state, action) => {
      state.itemInCart = state.itemInCart.filter(
        (item) => item.id !== action.payload
      );
    },
  },
});

export const { setItemInCart, deleteItemInCart, increaseQty, decreaseQty } =
  cartSlice.actions;
export default cartSlice.reducer;
